import React, { useState, useEffect } from 'react';
import ImageApi from '../../api/image';
import './knowledgebase.scss';

export default function KnowledgebaseItem({ image }) {
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    const fetchImageUrl = async () => {
      if (image && image.url) {
        try {
          const url = await ImageApi.getImage(image.url);
          setImageUrl(url);
        } catch (error) {
          console.error('Failed to fetch image:', error);
          setImageUrl('');
        }
      } else {
        setImageUrl('');
      }
    };

    fetchImageUrl();
  }, [image]);

  return (
    <img
      className="knowledgebase-item-content-image"
      src={imageUrl}
      width="100%"
      alt="post"
    />
  );
}
